import axios, { AxiosResponse } from 'axios';
import { ICustomerModel } from './CustomerModel';
import { ApiResponse, PageResponse } from '../../../shared/models/ApiModels';

// Base URL ayarı
const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

//  BASE URL 
export const CUSTOMER_CREATE_URL = `${API_URL}api/v1/customer/create`;
export const CUSTOMER_GET_ALL_URL = `${API_URL}api/v1/customer/all`;
export const CUSTOMER_DELETE_URL = `${API_URL}api/v1/customer/delete/`;
export const CUSTOMER_UPDATE_URL = `${API_URL}api/v1/customer/update/`;
export const CUSTOMER_GET_BY_ID_URL = `${API_URL}api/v1/customer/getById/`;

 
export async function createCustomer(customerData: ICustomerModel) {
  try {
    const { id, ...dataWithoutId } = customerData;
    const response = await axios.post(CUSTOMER_CREATE_URL, dataWithoutId);
    return response.data;
  } catch (error) {
    console.error('Müşteri oluşturma hatası:', error);
    throw error;
  }
}
 
export async function updateCustomer(customerData: ICustomerModel) {
  if (!customerData.id) {
    throw new Error('Güncelleme için müşteri ID’si gerekli.');
  }

  try {
    const response = await axios.patch(`${CUSTOMER_UPDATE_URL}${customerData.id}`, customerData);
    return response.data;
  } catch (error) {
    console.error('Müşteri güncelleme hatası:', error);
    throw error;
  }
}
 
export async function loadCustomer(
  page = 0, 
  size = 5, 
  sort: string = 'createdDate', 
  order: string = 'desc'
): Promise<AxiosResponse<ApiResponse<PageResponse<ICustomerModel>>>> {
  return axios.get(CUSTOMER_GET_ALL_URL, {
    params: { page, size, sort, order }
  });
}

/** Müşteri listeleme — filtre parametreleri backend ile uyumlu olacak şekilde iletilir */
export async function fetchCustomerList(
  filters: {
    searchKeyword?: string
    lastName?: string
    dateFilterType?: string
    startDate?: string
    endDate?: string
    cariTipi?: string
    activeStatus?: string
    allRecords?: boolean
  },
  page = 0,
  size = 25,
  sort = 'lastName',
  order: 'asc' | 'desc' = 'asc'
): Promise<AxiosResponse<ApiResponse<PageResponse<ICustomerModel>>>> {
  return axios.get(CUSTOMER_GET_ALL_URL, {
    params: {
      page,
      size,
      sort,
      order,
      ...filters,
    },
  })
}

 
export async function deleteCustomer(customerId: string) {
  try {
    const response = await axios.delete(`${CUSTOMER_DELETE_URL}${customerId}`);
    return response.data;
  } catch (error) {
    console.error('Müşteri silme hatası:', error);
    throw error;
  }
}

export async function getCustomerById(customerId: string) {
  try {
    const response = await axios.get(`${CUSTOMER_GET_BY_ID_URL}${customerId}`);
    return response.data.payload;
} catch (error) {
    console.error('Müşteri getirme hatası:', error);
    throw error;
  }
}